import { useState } from "react";

/**
 * Custom hook to manage alert notifications
 * @param {number} autoHideDuration - Duration in ms to auto-hide alerts (default: 5000)
 * @returns {Object} Alert state and control functions
 */
const useAlert = (autoHideDuration = 5000) => {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");

  // Timer reference to clear timeout if needed
  let alertTimer = null;

  /**
   * Shows an alert with the given message and severity
   * @param {string} message - Alert message text
   * @param {string} severity - Alert severity (success, error, warning, info)
   */
  const showAlert = (message, severity = "info") => {
    // Clear any existing timer
    if (alertTimer) {
      clearTimeout(alertTimer);
    }

    // Set alert properties
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);

    // Auto-hide after specified duration
    alertTimer = setTimeout(() => {
      setAlertOpen(false);
    }, autoHideDuration);
  };

  /**
   * Manually closes the alert
   */
  const closeAlert = () => {
    if (alertTimer) {
      clearTimeout(alertTimer);
    }
    setAlertOpen(false);
  };

  return {
    alertOpen,
    alertMessage,
    alertSeverity,
    showAlert,
    closeAlert,
  };
};

export default useAlert;
